import React from 'react';

import { FlagIcon } from 'components';

import './countryTitle.scss';

interface Props {
    countryCode: string;
    countryName: string;
}

const CountryTitle: React.FC<Props> = ({ countryCode, countryName }) => {
    return (
        <span styleName="container">
            {countryCode && <FlagIcon countryCode={countryCode} />}
            {countryName}
        </span>
    );
};

export default CountryTitle;
